<template>
    <v-navigation-drawer v-model="visible" :permanent="!$vuetify.display.mobile" :width="346" color="surface">
        <div class="py-3">
            <v-list class="px-6 pb-4">
                <v-list-item :to="{ name: 'myaccount' }" :active="false">
                    <template v-slot:prepend>
                        <v-avatar size="40">
                            <v-img v-if="user.avatar" :src="user.avatar" :alt="user.name" />
                            <v-icon v-else size="40">$accountCircle</v-icon>
                        </v-avatar>
                    </template>
                    <v-list-item-title class="text-body-medium font-weight-bold">{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle v-if="user.email" class="text-label-medium">
                        {{ user.email }}
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list>

            <v-divider class="my-0" />

            <v-list class="px-6">
                <!-- Dashboard -->
                <v-list-item :to="{ name: 'dashboard' }">
                    <template v-slot:prepend>
                        <v-icon>$dashboard</v-icon>
                    </template>
                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item>

                <!-- Campaign -->
                <div v-if="
                    user.permissions.includes('edit campaigns') ||
                    user.roles.includes('admin')
                ">
                    <v-list-item :to="{ name: 'campaigns.view' }" exact
                        @mouseenter="showHoverColor('campaigns-icon', 'text-fluxYellow')"
                        @mouseleave="hideHoverColor('campaigns-icon', 'text-fluxYellow')">
                        <template v-slot:prepend>
                            <v-icon id="campaigns-icon">$featuredPlayList</v-icon>
                        </template>
                        <v-list-item-title>Campaigns</v-list-item-title>
                    </v-list-item>

                    <v-list v-if="expandMenu('campaigns') || expandMenu('campaign')" density="compact">
                        <v-list-item style="padding-left: 72px" :to="{ name: 'campaigns.new' }">
                            <v-list-item-title class="text-body-medium">
                                New Campaign
                            </v-list-item-title>
                        </v-list-item>

                        <!-- Inside a campaign -->

                        <div v-if="expandMenu('campaign')">
                            <v-list-item style="padding-left: 72px" :to="{
                                name: 'campaign.view',
                                params: { id: this.$route.params.id },
                            }">
                                <v-list-item-title v-if="campaign" class="text-body-medium">
                                    {{ campaign.name }}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list>
                </div>

                <!-- Creatives -->
                <div v-if="
                    user.permissions.includes('edit creatives') ||
                    user.roles.includes('admin')
                ">
                    <v-list-item :to="{ name: 'creatives.view' }" exact
                        @mouseenter="showHoverColor('creatives-icon', 'text-accent')"
                        @mouseleave="hideHoverColor('creatives-icon', 'text-accent')">
                        <template v-slot:prepend>
                            <v-icon id="creatives-icon">$photoLibrary</v-icon>
                        </template>
                        <v-list-item-title>Creatives</v-list-item-title>
                    </v-list-item>

                    <v-list v-if="expandMenu('creatives') || expandMenu('creative')" density="compact">
                        <v-list-item style="padding-left: 72px" :to="{ name: 'creatives.new' }">
                            <v-list-item-title class="text-body-medium">
                                New Creative
                            </v-list-item-title>
                        </v-list-item>

                        <!-- Inside a creative -->

                        <div v-if="expandMenu('creative')">
                            <v-list-item style="padding-left: 72px" :to="{
                                name: 'creative.view',
                                params: { id: this.$route.params.id },
                            }">
                                <v-list-item-title v-if="creative" class="text-body-medium">
                                    {{ creative.name }}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list>
                </div>

                <!-- Profile -->
                <div v-if="
                    user.permissions.includes('edit profiles') ||
                    user.roles.includes('admin')
                ">
                    <v-list-item :to="{ name: 'profiles.view' }" exact
                        @mouseenter="showHoverColor('profiles-icon', 'text-fluxPurple')"
                        @mouseleave="hideHoverColor('profiles-icon', 'text-fluxPurple')">
                        <template v-slot:prepend>
                            <v-icon id="profiles-icon">$subscriptions</v-icon>
                        </template>
                        <v-list-item-title>Profiles</v-list-item-title>
                    </v-list-item>

                    <v-list v-if="expandMenu('profiles') || expandMenu('profile')" density="compact">
                        <v-list-item style="padding-left: 72px" :to="{ name: 'profiles.new' }">
                            <v-list-item-title class="text-body-medium">New Profile</v-list-item-title>
                        </v-list-item>
                        <!-- Inside a profile -->

                        <div v-if="expandMenu('profile')">
                            <v-list-item style="padding-left: 72px" :to="{
                                name: 'profile.view',
                                params: { id: this.$route.params.id },
                            }">
                                <v-list-item-title v-if="profile" class="text-body-medium">
                                    {{ profile.name }}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list>
                </div>

                <!-- Assets -->
                <!-- <div v-if="
                    user.permissions.includes('edit assets') ||
                    user.roles.includes('admin')
                ">
                    <v-list-item :to="{ name: 'assets.campaign' }" @mouseenter="
                        showHoverColor('assets-icon', 'text-info')
                        " @mouseleave="
                                hideHoverColor('assets-icon', 'text-info')
                                ">
                        <template v-slot:prepend>
                            <v-icon id="assets-icon">$photo</v-icon>
                        </template>
                        <v-list-item-title>Assets</v-list-item-title>
                    </v-list-item>
                </div> -->

                <!-- Conditions -->
                <div v-if="
                    user.permissions.includes('edit conditions') ||
                    user.roles.includes('admin')
                ">
                    <v-list-item :to="{ name: 'conditions.view' }" exact
                        @mouseenter="showHoverColor('conditions-icon', 'text-error')"
                        @mouseleave="hideHoverColor('conditions-icon', 'text-error')">
                        <template v-slot:prepend>
                            <v-icon id="conditions-icon">$api</v-icon>
                        </template>
                        <v-list-item-title>Conditions</v-list-item-title>
                    </v-list-item>

                    <v-list v-if="
                        expandMenu('conditions') || expandMenu('condition')
                    " density="compact">
                        <v-list-item style="padding-left: 72px" :to="{ name: 'conditions.new' }">
                            <v-list-item-title class="text-body-medium">
                                New Condition
                            </v-list-item-title>
                        </v-list-item>

                        <!-- Inside a condition -->

                        <div v-if="expandMenu('condition')">
                            <v-list-item style="padding-left: 72px" :to="{
                                name: 'condition.view',
                                params: { id: this.$route.params.id },
                            }">
                                <v-list-item-title v-if="condition" class="text-body-medium">
                                    {{ condition.name }}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list>
                </div>
            </v-list>
        </div>

        <v-footer absolute color="rgba(0,0,0,0)">
            <v-col class="text-center brand_copyright text-grey text-label-small" cols="12">
                <!-- &copy;{{ new Date().getFullYear() }} Flux Outdoor -->
            </v-col>
        </v-footer>
        <!-- </v-img> -->
    </v-navigation-drawer>
</template>

<script>
import { mapState, mapStores } from "pinia";
import { useUserStore } from "@/stores/user";
import { useCampaignsStore } from "@/stores/campaigns";
import { useCreativesStore } from "@/stores/creatives";
import { useProfilesStore } from "@/stores/profiles";
import { useConditionsStore } from "@/stores/conditions";
import eventBus from "../eventBus";

export default {
    data() {
        return {
            visible: null,
        };
    },
    computed: {
        ...mapState(useUserStore, ["user"]),
        ...mapStores(useCampaignsStore, useCreativesStore, useProfilesStore, useConditionsStore),
        campaign() {
            return this.campaignsStore.campaign(this.$route.params.id);
        },

        creative() {
            return this.creativesStore.creative(this.$route.params.id);
        },

        profile() {
            return this.profilesStore.profile(this.$route.params.id);
        },

        condition() {
            return this.conditionsStore.condition(this.$route.params.id);
        },
    },

    methods: {
        expandMenu(option) {
            const regex = /([A-Za-z0-1]+).*/;
            const matches = regex.exec(this.$route.name);
            return matches[1] == option;
        },

        showHoverColor(elementId, classToAdd) {
            const el = document.getElementById(elementId);
            el.classList.add(classToAdd);
        },
        hideHoverColor(elementId, classToRemove) {
            const el = document.getElementById(elementId);
            el.classList.remove(classToRemove);
        },
    },
    mounted() {
        this._onToggleSidebar = () => {
            this.visible = !this.visible;
        };
        eventBus.on("TOGGLE_SIDEBAR", this._onToggleSidebar);
    },
    beforeUnmount() {
        eventBus.off("TOGGLE_SIDEBAR", this._onToggleSidebar);
    },
};
</script>
